const ru_alert = document.getElementById("ru-alert");
const ru_alert_text = document.getElementById("ru-alert-text");
const popup_priserdv = document.getElementById("ru-popup_prise_rdv");
const urlParams = new URLSearchParams(window.location.search);
const all_html = document.getElementById("ru-html");
const ru_popup_prise_rdv_btn_tel = document.getElementById("ru_popup_prise_rdv_btn_tel");

//popin alerte "a venir"
function hide_alert() {
  ru_alert.classList.add("d-none");
}

function display_alert(success, text) {
  ru_alert_text.textContent = text;
  if(success) {
    ru_alert.classList.add("ru-alert-success");
  }else{
    ru_alert.classList.add("ru-alert-error");
  }
  ru_alert.classList.remove("d-none");
  setTimeout(function () {ru_alert.classList.add("d-none");ru_alert.classList.remove("ru-alert-success");ru_alert.classList.remove("ru-alert-error");}, 3000);
}

// bing add to cart
function uet_add_to_cart(product_name, product_price) {
  window.uetq = window.uetq || [];
  window.uetq.push("event", "add_to_cart", {"revenue_value":product_price, "currency":"EUR"});
}

//add to cart avec et sans redirection
function ru_addToCart(id, redirectToCart = false, variantauto = false, max = 0, product_name = "", product_price = 0, product_id = 0) {
  let variantValue = false;
  if (variantauto) {
    var url = window.location.href;
    var parsedUrl = new URL(url);
    variantValue = parsedUrl.searchParams.get("variant");
  }
  id = variantValue ? variantValue : id;

  if(max == 0){
    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 'items': [{ 'id': variantValue ? variantValue : id, 'quantity': 1 }] })
    })
    .then((resp) => {
      if (resp.status === 200) {
        const cart_count = document.getElementById("header__cart-count");
        let newValue = parseInt(cart_count.textContent) + 1;
        cart_count.textContent = newValue.toString();
        uet_add_to_cart(product_name, product_price);
        if (!redirectToCart) {
          display_alert(1, "Produit ajouté");
        }
      } else if (resp.status === 422) {
        if (!redirectToCart) {
          display_alert(0, "Article déjà dans le panier");
        }
      } else {
        if (!redirectToCart) {
          display_alert(0, "Erreur lors de l'ajout du produit");
        }
      }
      if (redirectToCart) {
        window.location.href = 'https://rutile.bike/cart';
      }
    })
    .catch((error) => {
      display_alert(0, "Erreur lors de l'ajout du produit");
      if (redirectToCart) {
        window.location.href = 'https://rutile.bike/cart';
      }
    });
  }else{
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(cartData => {
        let varianteQuantity = 0;
        const variantInCart = cartData.items.find(item => String(item.variant_id) == id);
        if(variantInCart){
          varianteQuantity = variantInCart.quantity;
        }
        if(varianteQuantity < max){
          fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ 'items': [{ 'id': variantValue ? variantValue : id, 'quantity': 1 }] })
          })
          .then((resp) => {
            if (resp.status === 200) {
              const cart_count = document.getElementById("header__cart-count");
              let newValue = parseInt(cart_count.textContent) + 1;
              cart_count.textContent = newValue.toString();
              uet_add_to_cart(product_name, product_price);
              if (!redirectToCart) {
                display_alert(1, "Produit ajouté");
              }
            } else if (resp.status === 422) {
              if (!redirectToCart) {
                display_alert(0, "Article déjà dans le panier");
              }
            } else {
              if (!redirectToCart) {
                display_alert(0, "Erreur lors de l'ajout du produit");
              }
            }
            if (redirectToCart) {
              window.location.href = 'https://rutile.bike/cart';
            }
          })
          .catch((error) => {
            display_alert(0, "Erreur lors de l'ajout du produit");
            if (redirectToCart) {
              window.location.href = 'https://rutile.bike/cart';
            }
          });
        }else{
          display_alert(0, "Article déjà dans le panier");
          if (redirectToCart) {
            window.location.href = 'https://rutile.bike/cart';
          }
        }
        })
      .catch(error => display_alert(0, "Erreur lors de l'ajout du produit"));  
  }
}

//wpm no index
let currentUrl = window.location.href;
if (currentUrl.includes('wpm@') || currentUrl.includes('web-pixels-manager@')) {
  let metaTag = document.createElement('meta');
  metaTag.name = 'robots';
  metaTag.content = 'noindex';
  document.head.appendChild(metaTag);

  let existingMetaTag = document.querySelector('meta[name="robots"][content="index,follow"]');
  if (existingMetaTag) {
    existingMetaTag.remove();
  }
}

//popup rdv
function display_priserdv_tel() {
  ru_popup_prise_rdv_btn_tel.classList.remove("d-none");
  display_priserdv()
}

function display_priserdv() {
  popup_priserdv.classList.remove("d-none");
  all_html.classList.add("over-hiden");
}

function hide_priserdv() {
  popup_priserdv.classList.add("d-none");
  all_html.classList.remove("over-hiden");
  ru_popup_prise_rdv_btn_tel.classList.add("d-none");
}

//popup rdv default open
if (urlParams.has('type_rdv')) {
    if (urlParams.get('type_rdv') === 'open') {
        display_priserdv();
    }
}

//accordeon
const accordionTitles = document.querySelectorAll(".ru-produit-accordionTitle-script");
accordionTitles.forEach((accordionTitle) => {
  const toggleText = accordionTitle.querySelector(".ru-accordion-toggle-text");
  
  accordionTitle.addEventListener("click", () => {
    const accordionContent = accordionTitle.nextElementSibling;
    if (accordionTitle.classList.contains("is-open")) {
      accordionTitle.classList.remove("is-open");
      accordionContent.style.maxHeight = 0;
      if(toggleText){
        toggleText.textContent = "Voir plus";
      }
    } else {
      accordionTitle.classList.add("is-open");
      accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
      if(toggleText){
        toggleText.textContent = "Voir moins";
      }
    }
  });
});

//validate tel
function validateTelInput(input){
  if(!input.value || input.value.match(/(^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$|^(?:(?:\+|00)33[\s.-]{0,3}(?:\(0\)[\s.-]{0,3})?|0)[1-9](?:(?:[\s.-]?\d{2}){4}|\d{2}(?:[\s.-]?\d{3}){2})$)/g) ){
      input.setCustomValidity('');
  }else{
      input.setCustomValidity("Numéro de téléphone invalide");
  }
}

// menu background black
document.addEventListener('DOMContentLoaded', () => {
  const sectionHeaderAndNav = document.querySelector('section[data-section-id="header"][data-section-type="header"]');
  const overlayNavLink = document.getElementById('ru-overlay-nav-link');
  if (sectionHeaderAndNav) {
    sectionHeaderAndNav.addEventListener('mouseenter', () => {
      if (!isMobileDevice()) {
        overlayNavLink.classList.add('visible');
      }
    });
    sectionHeaderAndNav.addEventListener('mouseleave', () => {
      overlayNavLink.classList.remove('visible');
    });
  } else {
    console.error('Section with specified attributes not found.');
  }

  function isMobileDevice() {
    return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1);
  }
});

// ---- START Custom NEAT App code
const removeInsuranceFromProduct = async (productId) => {
  const res = await fetch(`${window.Shopify.routes.root}cart.js`);
  const cart = await res.json();
  const cartItem = cart.items.find((item) => item.id === Number(productId));
  let properties = cartItem.properties;
  let propertiesToRemove = ["_isInsured", "_insuredById"];
  propertiesToRemove.push(Object.keys(properties).find((key) => properties[key].includes("NEAT")));
  propertiesToRemove.map((property) => {
    delete properties[property];
  });
  if (Object.values(properties).length === 0) {
    // Required because you cannot have an empty properties object if it was once set.
    // @see https://shopify.dev/docs/api/ajax/reference/cart#update-properties
    properties = { _empty: true };
  }

  await fetch(window.Shopify.routes.root + "cart/change.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: cartItem.key, properties }),
  });
};

const removeInsuranceFromCart = () => {
  const decreaseButtons = document.querySelectorAll(
    '[data-action="decrease-quantity"], [data-action="decrease-quantity-custom"], [data-action="decrease-quantity-test"]'
  );

  decreaseButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      const parentWithProductId = button.closest("[data-product-id]");
      const productId = parentWithProductId.getAttribute("data-product-id");
      const productItemCartKey = parentWithProductId.getAttribute("data-item-key");
      const matchingInsuranceItem = document.querySelector(`[data-insured-product-id="${productId}"]`);
      let insuranceItemCartKey = null;

      const updates = {
        [productItemCartKey]: 0,
      };
      if (matchingInsuranceItem) {
        insuranceItemCartKey = matchingInsuranceItem.getAttribute("data-item-key");
        updates[insuranceItemCartKey] = 0;
      }

      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates }),
      });

      if (parentWithProductId.hasAttribute("data-insured-product-id")) {
        await removeInsuranceFromProduct(parentWithProductId.getAttribute("data-insured-product-id"));
      }

      window.location.reload();
    });
  });
};
removeInsuranceFromCart();
// ---- END Custom NEAT App code